module.exports = __webpack_public_path__ + "media/public/images/icon-trigger-blue-80a2c3e7bf0375c27ef9305543674e6d.svg";